import { useDispatch, useSelector } from 'react-redux';
import { signOut } from 'firebase/auth';

import { auth } from '../../app/firebase';
import { selectUsers, setUser } from '../../features/users/usersSlice';
import LandingHeaderSection from '../landingPage/landingHeaderSection';
import {
  LandingContainer,
  LandingPageRoot,
  LoginPageSection,
} from '../landingPage/landingPage.styles';
import { WebSunsetNotice } from './webSunsetNotice';

export function WebSunsetPage({ signedIn = false }) {
  const dispatch = useDispatch();
  const { currentUser } = useSelector(selectUsers);

  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        dispatch(setUser(null));
      })
      .catch((error) => {
        console.error('Logout error:', error);
      });
  };

  return (
    <LandingPageRoot>
      <LandingHeaderSection />
      <LandingContainer>
        <LoginPageSection>
          <WebSunsetNotice
            signedIn={signedIn}
            email={currentUser?.email}
            onLogout={signedIn ? handleLogout : undefined}
          />
        </LoginPageSection>
      </LandingContainer>
    </LandingPageRoot>
  );
}
